import script from "./OfferAssignDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./OfferAssignDialog.vue?vue&type=script&setup=true&lang=js"

import "./OfferAssignDialog.vue?vue&type=style&index=0&id=0f10d2a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f10d2a0"]])

export default __exports__